var map = {
	"./bank-account.png": "3ec3",
	"./branch.png": "6e3d",
	"./crm.png": "9743",
	"./currency.png": "010ec",
	"./halal.svg": "c572",
	"./home.svg": "c798",
	"./iso.png": "59c2",
	"./reporting.png": "05d4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "647f";